import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Alert,
} from '@mui/material';

const DisburseDialog = ({ open, onClose, selectedItem, disbursementData, onDisbursementDataChange, onSubmit }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Disburse Funds</DialogTitle>
    <DialogContent>
      {selectedItem && (
        <>
          <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
            Item: <strong>{selectedItem.title}</strong>
            <br />
            Total Cost: <strong>${parseFloat(selectedItem.cost).toLocaleString()}</strong>
            <br />
            Already Disbursed: <strong>${parseFloat(selectedItem.amount_disbursed || 0).toLocaleString()}</strong>
            <br />
            Remaining: <strong>${(parseFloat(selectedItem.cost) - parseFloat(selectedItem.amount_disbursed || 0)).toLocaleString()}</strong>
          </Alert>
          <TextField
            margin="dense"
            label="Disbursement Amount"
            fullWidth
            variant="outlined"
            type="number"
            value={disbursementData.amount}
            onChange={(e) => onDisbursementDataChange({ ...disbursementData, amount: e.target.value })}
            sx={{ mb: 2 }}
            inputProps={{
              step: '0.01',
              min: '0',
              max: (parseFloat(selectedItem.cost) - parseFloat(selectedItem.amount_disbursed || 0)).toString(),
            }}
          />
          <TextField
            margin="dense"
            label="Check Number (Optional)"
            fullWidth
            variant="outlined"
            value={disbursementData.check_number}
            onChange={(e) => onDisbursementDataChange({ ...disbursementData, check_number: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Notes (Optional)"
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={disbursementData.notes}
            onChange={(e) => onDisbursementDataChange({ ...disbursementData, notes: e.target.value })}
          />
        </>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        color="success"
        disabled={!disbursementData.amount || parseFloat(disbursementData.amount) <= 0}
      >
        Disburse Funds
      </Button>
    </DialogActions>
  </Dialog>
);

export default DisburseDialog;
